<template>
    <div v-if="licensed" class="user-panel">
        <template v-if="!appData.tenantAdminUser">
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    {{ $t('message.item_buddy_bot_api_setting') }}
                </div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <td width=50% class="object-item">{{$t('message.error_cannot_operate_no_tenantAdmin_privilege')}}</td>
                </table>
            </div>
        </template>

        <template v-else>
            <table>
                <tbody>
                <tr class="itemheader">
                    <td>
                        <div class="inner-panel">
                            <template>
                                <template>
                                    <div class="object-titlebox">
                                        <table width="100%">
                                            <tbody>
                                            <tr>
                                                <td style="width:50%;padding-left:20px;padding-top:10px;text-align:left">
                                                    <span class="keyvalut-header-text" v-t="'message.item_buddy_bot_api_setting'"></span>
                                                </td>
                                                <td style="padding-right:10px;text-align:right">
                                                    <span class="keyvalut-header-text" style="margin-right:10px">{{ $t("message.item_buddy_bot_api_remaining_request_count") }}:{{ this.remainingLimitCount }}</span>
                                                    <button class="transparent-button" type="button">
                                                        <img src="../../../../assets/add_user.svg" alt=""/>
                                                        <span class="normal-command-text" v-t="'message.item_buddy_bot_api_add_bot'" @click="showAddBotDialog"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <table style="table-layout:fixed;width:100%">
                                        <tbody>
                                        <tr class="keyvalut-header-record">
                                            <td class="keyvalut-header-item" v-t="'message.item_display_name'"></td>
                                            <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.item_buddy_bot_api_get_token'"></td>
                                            <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_select_user'"></td>
                                            <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_edit'"></td>
                                            <td class="keyvalut-header-item" style="width:10%;text-align:center" v-t="'message.common_action_delete'"></td>
                                        </tr>
                                        </tbody>
                                        <tr class="objectitem-record" v-for="chatBot in chatBotList" :key="chatBot.userId">
                                            <td class="object-item">{{ chatBot.displayName }}</td>
                                            <td class="object-item" style="width:10%;text-align:center">
                                                <button class="item-record-button" type="button" @click="showTokenDialog(chatBot.userId)">
                                                    <img src="../../../../assets/icon_lock.svg" alt=""/>
                                                </button>
                                            </td>
                                            <td class="object-item" style="width:10%;text-align:center">
                                                <button class="item-record-button" type="button" @click="showAssignUserDialog(chatBot.userId)">
                                                    <img src="../../../../assets/add_user.old.svg" alt=""/>
                                                </button>
                                            </td>
                                            <td class="object-item" style="width:10%;text-align:center">
                                                <button class="item-record-button" type="button" @click="showEditBotDialog(chatBot.userId)">
                                                    <img src="../../../../assets/edit.svg" alt=""/>
                                                </button>
                                            </td>
                                            <td class="object-item" style="width:10%;text-align:center">
                                                <button class="item-record-button" type="button" @click="showDeleteBotDialog(chatBot.userId)">
                                                    <img src="../../../../assets/icon_delete_user.svg" alt=""/>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                            </template>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
        <DeleteBuddyBot v-if="isDeleteDialogOpen" :targetBotInfo="targetBotInfo" @delete=deleteBuddyBot @cancel="isDeleteDialogOpen=false"></DeleteBuddyBot>
        <BuddyBotParams v-if="isParamsDialogOpen" :targetBotInfo="targetBotInfo" :targetBotParam="botParam" @add=addBuddyBot @modify=modifyBuddyBot @showJsonDialog=showJsonDialog @cancel="isParamsDialogOpen=false"></BuddyBotParams>
        <AssignUser v-if="isAssignUserOpen" :chatBot="targetBotInfo" :tenantId="appData.tenantList[0].tenantId" :assignedUserList="chatBotAssignedUserList" @save=assignUserToChatBot @cancel="isAssignUserOpen=false"></AssignUser>
        <BuddyBotToken v-if="isTokenDialogOpen" :tokenInfo="tokenInfo" @cancel="isTokenDialogOpen=false" @close="isTokenDialogOpen=false"/>
    </div>
    <div v-else class="object-inner-table">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_buddy_bot_api_setting'"></div>
        </div>
        <div class="default-message" style="padding-top: 10vh;">
            <span v-t="'message.info_buddy_bot_api_restriction'"></span><br><br>
        </div>
    </div>
</template>

<script>
import server from "../../../ServerApi";
import BuddyBotParams from "./BuddyBotParams.vue";
import DeleteBuddyBot from "./DeleteBuddyBot.vue";
import constants from "../../../constants";
import commonUtil from "../../../commonutil";
import AssignUser from "../../key/thirdai/AssignUser.vue";
import BuddyBotToken from "./BuddyBotToken.vue";
import BuddyBotPayloadSample from "./BuddyBotPayloadSample.vue";

export default {
    data() {
        return {
            licensed: false,
            isParamsDialogOpen: false,
            isDeleteDialogOpen: false,
            isAssignUserOpen: false,
            isTokenDialogOpen: false,

            targetBotInfo: {
                userId: null,
                displayName: null,
                userName: null,
                parentName: null,
                categoryValue: null,
                typeValue: null,
            },
            botParam: {
                objectName: null,
                displayName: null,
                endpoint: null,
                ignoreWords: null,
                authKey: null,
                authValue: null,
                customParamsJson: null,
            },
            tokenInfo: {
                id: null,
                displayName: null,
                token: null,
            },

            chatBotAssignedUserList: [],

            chatBotList: [],

            remainingLimitCount: 0,
        };
    },

    methods: {
        fetchRemainigLimitCount() {
            server.post('/fetchbuddybotremaining').then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.remainingLimitCount = res.data.remainingCount;
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchBuddyBotRemaining").replace("{code}", res.data.status));
                        break;
                }
            })
        },
        fetchBuddyBotList() {
            server.post('/getassistantlist', {
                category: constants.ASSISTANT_CATEGORY_CUSTOM,
                type: constants.ASSISTANT_CUSTOM_BUDDY_BOT,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.chatBotList = [];
                        for (let buddyBot of res.data.assistantList) {
                            this.chatBotList.push(buddyBot)
                        }
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        /*nop*/
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getThirdAiChatBotList").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchBuddyboundBotList", error);
            });
        },
        getBuddyBot(successCallback) {
            server.post('/getbuddybot', {
                objectId: this.targetBotInfo.userId,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.targetBotInfo.userId = res.data.objectId;
                        this.botParam.objectName = res.data.objectName;
                        this.botParam.displayName = res.data.displayName;
                        this.botParam.endpoint = res.data.endpoint;
                        this.botParam.ignoreWords = res.data.ignoreWords;
                        this.botParam.authKey = res.data.authKey;
                        this.botParam.authValue = res.data.authValue;
                        this.botParam.customParamsJson = res.data.customParamsJson;
                        successCallback();
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getbuddyBot").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "getbuddyBot", error)
            })
        },
        addBuddyBot(input) {
            this.isParamsDialogOpen = false;
            server.post('/addbuddybot', {
                displayName: input.displayName,
                objectName: input.objectName,
                endpoint: input.endpoint,
                ignoreWords: input.ignoreWords,
                authKey: input.authKey,
                authValue: input.authValue,
                customParamsJson: input.customParamsJson,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_add_success"));
                        this.fetchBuddyBotList()
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_exceeds_max_chat_bot"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "addBuddyBot").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "addbuddyBot", error)
            })
        },
        modifyBuddyBot(input) {
            this.isParamsDialogOpen = false;
            server.post('/modifybuddybot', {
                objectId: this.targetBotInfo.userId,
                info: {
                    displayName: input.displayName,
                    objectName: input.objectName,
                    endpoint: input.endpoint,
                    ignoreWords: input.ignoreWords,
                    authKey: input.authKey,
                    authValue: input.authValue,
                    customParamsJson: input.customParamsJson,
                }
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_modify_success"));
                        this.fetchBuddyBotList()
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "modifybuddyBot").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "modifybuddyBot", error)
            })
        },
        deleteBuddyBot() {
            this.isDeleteDialogOpen = false;
            server.post('/deleteassistant', {
                objectId: this.targetBotInfo.userId,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_delete_success"));
                        this.fetchBuddyBotList()
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deletebuddyBot").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "deletebuddyBot", error)
            });
        },
        assignUserToChatBot(input) {
            this.isAssignUserOpen = false;
            let addIdList = [];
            let removeIdList = [];

            for (let key in input.addTagList) {
                addIdList.push(input.addTagList[key].id);
            }

            for (let key in input.removeTagList) {
                removeIdList.push(input.removeTagList[key].id);
            }

            let self = this;
            server.post('/updateassistantuser', {
                chatBotId: this.targetBotInfo.userId,
                addIdList: addIdList,
                removeIdList: removeIdList,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_updated_assistant_user"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                        commonUtil.notifyMessage(self, 'Warning', commonUtil.getMessageText(self.$i18n, "error_exceeds_max_assistant_user"));
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "assignUserToChatBot").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(self, "assignUserToChatBot", error);
            });
        },
        checkLicense(callback) {
            this.licensed = this.appData.enableBuddyBotApi || this.appData.enableBuddyBotApiTrial
            if (this.licensed) {
                callback()
            }
        },
        showAddBotDialog() {
            this.targetBotInfo = {
                id: null,
                displayName: null,
                categoryValue: null,
                typeValue: null,
            };
            this.botParam = {
                displayName: null,
                endpoint: null,
                ignoreWords: null,
                authValue: null,
                customParams: null,
            };
            this.isParamsDialogOpen = true;
        },
        showDeleteBotDialog(id) {
            this.targetBotInfo = this.chatBotList.find(bot => bot.userId === id);
            this.isDeleteDialogOpen = true;
        },
        showEditBotDialog(id) {
            this.targetBotInfo = this.chatBotList.find(bot => bot.userId === id);
            this.getBuddyBot(() => {
                this.isParamsDialogOpen = true;
            });
        },
        showAssignUserDialog(id) {
            this.targetBotInfo = this.chatBotList.find(bot => bot.userId === id);
            server.post('/fetchassistantuser', {
                chatBotId: this.targetBotInfo.userId
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.chatBotAssignedUserList = res.data.userList;
                        this.isAssignUserOpen = true;
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchAssistantUser").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "fetchAssistantUser", error);
            });
        },
        showTokenDialog(id) {
            this.targetBotInfo = this.chatBotList.find(bot => bot.userId === id);
            this.tokenInfo = {
                id: id,
                displayName: this.targetBotInfo.displayName,
                token: null,
            };
            server.post('/getassistanttoken', {
                objectId: id,
                shouldRegenerate: false,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.tokenInfo.token = res.data.token;
                        this.isTokenDialogOpen = true;
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getAssistantToken").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "getAssistantToken", error);
            })
        },
        showJsonDialog(input) {
            this.botParam = input;
            this.isSampleDialogOpen = true;
        },
    },
    components: {
        DialogJsonSample: BuddyBotPayloadSample,
        BuddyBotToken: BuddyBotToken,
        AssignUser,
        DeleteBuddyBot: DeleteBuddyBot,
        BuddyBotParams: BuddyBotParams,
    },

    created: function () {
        this.checkLicense(() => {
            this.fetchBuddyBotList()
            this.fetchRemainigLimitCount()
        });
    },
    props: ['appData']
}
</script>

<style>

.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel {
    position: relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.keyvalut-header-record {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}

.keyvalut-header-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}

.keyvalut-header-text {
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

</style>
